module.exports = __webpack_public_path__ + "img/claimpending.b5733cc4.svg";